import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationBottomHeader from './TopNavigationBottomHeader';

export default withNavigationTheme(TopNavigationBottomHeader);
